import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const BlogSingle = () => {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await fetch(`https://wp1.edukacija.online/backend/wp-json/wp/v2/posts/${id}`);
        if (!response.ok) {
          throw new Error(`Greška: ${response.status}`);
        }
        const data = await response.json();
        setPost(data);
      } catch (error) {
        setError(error.message);
      }
    };

    fetchPost();
  }, [id]);

  if (error) return <p>Greška: {error}</p>;
  if (!post) return <p>Učitavanje...</p>;

  return (
    <section className="recept-section">
      <div className="recept-container">
        {/* HTML sadržaj recepta iz WordPressa */}
        <div dangerouslySetInnerHTML={{ __html: post.content.rendered }} />
      </div>
    </section>
  );
};

export default BlogSingle;
